/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Placeholder2Inputs */

const en_coinvestments_editemail_placeholder2 = /** @type {(inputs: Coinvestments_Editemail_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your custom email text here...`)
};

/**
* | output |
* | --- |
* | "Enter your custom email text here..." |
*
* @param {Coinvestments_Editemail_Placeholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_placeholder2 = /** @type {((inputs?: Coinvestments_Editemail_Placeholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Placeholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_placeholder2(inputs)
});
export { coinvestments_editemail_placeholder2 as "coInvestments_editEmail_placeholder" }